// Returns a copy of the provided object with all properties with falsy values removed
const compactObject = (obj: object) =>
    Object.fromEntries(Object.entries(obj).filter(([_, value]) => !!value))

export default compactObject
